export default {
  duplicateQueueTime: "The duration of not registering a repeat appointment",
};
